/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OperationStatus = null | null;

export const OperationStatus = {
    NUMBER_null: null as OperationStatus,
    NUMBER_null2: null as OperationStatus
};

